import { render } from "./FilterItems.vue?vue&type=template&id=3adbc8a3"
import script from "./FilterItems.vue?vue&type=script&lang=js"
export * from "./FilterItems.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__